 const jobContentFields = [
    {key: 'field_description', label: 'Description', anchor: 'desc'},
    {key: 'field_required_qualifications', label: 'Required qualifications', anchor: 'req'},
    {key: 'field_preferred_qualifications', label: 'Preferred qualifications', anchor: 'pref'},
    {key: 'field_benefits', label: 'Benefits', anchor: 'bene'}
]

export default jobContentFields;